import { defineStore } from 'pinia'

export const Specialists = defineStore({
    id: 'wp_specialists',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const WeekDura = defineStore({
    id: 'wp_week_duration',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})

export const WeekGenerated = defineStore({
    id: 'wp_week_generated',
    state: () => {
        return { value: null }
    },
    actions: {
        get() {
            return this.value
        },
        set(data) {
            this.value = data
        }
    },
})
